
'use client'
import { Flex, Avatar, Popover, Dropdown } from 'antd'
import { useData } from '@/context/hooks/DataProvider'
import { HomeOutlined, UserOutlined, DownOutlined } from "@ant-design/icons";
import Link from 'next/link';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { useRouter } from 'nextjs-toploader/app';

const ossUrl = 'https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/'
export default function HeaderBar() {

    const { user, isLoading, openLogin, logout } = useData();

    const [isLoadingOver, setIsLoadingOver] = useState(false);

    const router = useRouter();

    if (isLoading) return <div>Loading...</div>

    useEffect(() => {

        if (typeof window !== 'undefined') {
            setIsLoadingOver(true);
        }
    }, []);

    const handleToDownPage = (type) => {
        let url = type == 1 ? 'https://apps.apple.com/cn/app/id1493358574' : 'https://play.google.com/store/apps/details?id=com.microants.international';
        window.open(url)
    }

    const content = (
        <div className={'header-popover'}>
            <div className={'header-popover-title'}>Download YiwuTrade app</div>
            <div style={{ display: 'flex' }}>
                <div>
                    <img
                        style={{ width: 150, height: 150, marginRight: 10 }}
                        src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/admin/buyerHome/downLoad_app.jpg"
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                    }}
                >
                    <div className='header-popover-img-container'>
                        <img
                            src={ossUrl + 'btn_appStore.png'}
                            className={'header-popover-img'}
                            onClick={() => handleToDownPage(1)}
                        />
                    </div>
                    <div className='header-popover-img-container'>
                        <img
                            src={ossUrl + 'btn_googlePlay.png'}
                            className={'header-popover-img'}
                            onClick={() => handleToDownPage(2)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );


    const handleToPage = (path = '/', blank) => {
        if (!user) {
            openLogin();
            return;
        }

        if (blank) {
            window.open(`${path}?t=${Date.now()}`);
            // window.open(`http://yiwutrade.s-ant.cn/supplier/Dashboard?t=${Date.now()}`, '_blank');
            return;
        }

        router.push(path);
    }

    const items = [
        {
            key: '1',
            label: <Link target="_blank" href="/buyer/inquiries">My Inquiries</Link>
        },
        {
            key: '2',
            label: <Link target="_blank" href="/buyer/rfq">My RFQs</Link>
        },
        {
            key: '3',
            label: <Link target="_blank" href="/buyer/favorites">My Favorites</Link>
        },
        {
            key: '4',
            label: <Link target="_blank" href="/buyer/profile">Buyer Central</Link>
        },
        {
            key: '5',
            label: <span>Sign Out</span>
        },

    ]

    const handleClickMenu = (e) => {
        if (e.key == '5') {
            logout();
        }
    }

    return (
        <nav>
            <Flex align='center' justify='space-around' className="header-bar">
                {
                    !isLoadingOver ? <></> :

                        user?.iconUrl ? <>
                            <div className='header_bar_item' onClick={() => handleToPage()}>
                                {/* <HomeOutlined className='header_bar_item_icon icon_flex' /> */}
                                {/* <Flex align='center' justify='center' style={{ height: 30 }}>
                                <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_home.png" alt='home' width={26} height={24} />
                            </Flex> */}
                                <div className='header_bar_item_icon icon_home'></div>
                                <p>Home</p>
                            </div>
                            <div className='header_bar_item' onClick={() => handleToPage('/supplier/Dashboard', true)}>
                                {/* <UserOutlined className='header_bar_item_icon icon_flex' /> */}
                                {/* <Flex align='center' justify='center' style={{ height: 30 }}>
                                <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_user.png" alt='user' width={20} height={23} />
                            </Flex> */}
                                <div className='header_bar_item_icon icon_user'></div>
                                <p>Seller Center</p>
                            </div>
                            <div className='header_bar_item'>
                                <Dropdown menu={{ items, onClick: handleClickMenu }}>
                                    <Flex align='center' vertical flex={1} justify='space-around'>
                                        <Avatar size={30} src={user?.iconUrl && <Image src={user.iconUrl} alt='user avatar' width={30} height={30} />}>USER</Avatar>
                                        <p>{user?.nickname}</p>
                                    </Flex>
                                </Dropdown>
                                {/* <p>Seller</p> */}
                            </div>
                        </>
                            :
                            <>
                                <Link className='header_bar_btn' href="/supplier/login">
                                    Sign in/Register
                                </Link>
                                <Link className='header_bar_btn' href="/supplier/Dashboard">
                                    Become a seller
                                </Link>
                            </>
                }

                <Popover placement="bottomRight" content={content} trigger="hover">
                    <div className='header_btn_get_app'>
                        Get the app <DownOutlined />
                    </div>
                </Popover>

                <Link className='header_bar_line' href="https://www.iyicaibao.com/" target="_blank">
                    <Image className='icon_lang' alt='Language' src={`${ossUrl}icon_earth.png`} width={16} height={16} />
                    <span>简体中文</span>
                </Link>
            </Flex>
        </nav>
    );
}